/* On Sky — couche « premium » : flèches des boutons + apparition au défilement (2026-10-17) */
(function(){
  /* 0. Pendant l'édition Halloween, une seule offre : la popup BIENVENUE10 se tait jusqu'au 31/10 23:59. */
  if(Date.now()<Date.parse('2026-10-31T23:59:59+01:00'))document.documentElement.classList.add('osk-hw');
  /* 1. Les boutons portent leur flèche dans une bulle (CSS ::after) : on retire la flèche tapée dans le texte. */
  var BTN='.cr-btn,.cr-link,.pq-cta,.rv-cta,.nl-form button,.ohs-all,.ohw-btn--p,.ohn-btn';
  function cleanArrows(root){
    [].forEach.call((root||document).querySelectorAll(BTN),function(b){
      if(b.getAttribute('data-osk'))return; b.setAttribute('data-osk','1');
      [].forEach.call(b.childNodes,function(n){ if(n.nodeType===3) n.nodeValue=n.nodeValue.replace(/\s*[→↗]\s*$/,''); });
    });
  }
  /* 2. Apparition douce : une fois par section, quand elle entre à l'écran. */
  var SEL='.cr,[id^="opr-"],.oac,.ost,.pq,.rv,.nl,.av,[id^="ohs-"],[id^="ohn-"]';
  function reveal(){
    if(!('IntersectionObserver' in window))return;
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('osk-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.06});
    var els=[];
    [].forEach.call(document.querySelectorAll(SEL),function(el){
      var r=el.getBoundingClientRect(); if(r.top<innerHeight*.9)return;      /* ce qui est déjà visible ne bouge pas */
      el.classList.add('osk-rv'); io.observe(el); els.push(el);
    });
    /* filet de sécurité : rien ne doit jamais rester caché (défilement très rapide, ancre, impression, robots) */
    function all(){els.forEach(function(el){el.classList.add('osk-in')});}
    var t=0;function arm(){clearTimeout(t);t=setTimeout(all,2500);}
    window.addEventListener('scroll',arm,{passive:true});arm();
    window.addEventListener('beforeprint',all);window.addEventListener('pagehide',all);
  }

  /* 3. Rangées horizontales sur ordinateur : flèches + glisser à la souris (la molette verticale ne fait pas défiler en largeur). */
  var ROWS='.cr-grid,[id^="ohs-"] .ohs-row'; /* paires uniquement : avis et stories gardent leur défilement d'origine */
  function rows(){
    if(!(window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches))return;
    [].forEach.call(document.querySelectorAll(ROWS),function(row){
      if(row.getAttribute('data-osk-row'))return; row.setAttribute('data-osk-row','1');
      var host=row.parentNode; if(getComputedStyle(host).position==='static')host.style.position='relative';
      function mk(dir){var b=document.createElement('button');b.type='button';b.className='osk-arrow osk-arrow--'+(dir<0?'prev':'next');
        b.setAttribute('aria-label',dir<0?'Précédent':'Suivant');
        b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(dir<0?'M15 18l-6-6 6-6':'M9 18l6-6-6-6')+'"/></svg>';
        b.addEventListener('click',function(){row.scrollBy({left:dir*Math.max(row.clientWidth*.85,240),behavior:'smooth'})});
        host.appendChild(b);return b}
      var pv=mk(-1),nx=mk(1);
      function upd(){var max=row.scrollWidth-row.clientWidth-2;var on=max>4;pv.hidden=!on||row.scrollLeft<=2;nx.hidden=!on||row.scrollLeft>=max}
      row.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();setTimeout(upd,800);
      /* glisser 1:1 à la souris, avec seuil de 6 px pour ne pas casser les clics */
      var down=false,x0=0,s0=0,moved=false,snap='';
      row.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;down=true;moved=false;x0=e.clientX;s0=row.scrollLeft});
      window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-x0;
        if(!moved&&Math.abs(dx)>6){moved=true;snap=row.style.scrollSnapType;row.style.scrollSnapType='none';row.classList.add('osk-dragging')}
        if(moved)row.scrollLeft=s0-dx});
      window.addEventListener('pointerup',function(){if(!down)return;down=false;if(moved){row.classList.remove('osk-dragging');row.style.scrollSnapType=snap;setTimeout(function(){moved=false},0)}});
      row.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation()}},true);
      row.addEventListener('dragstart',function(e){e.preventDefault()});
    });
  }
  /* 4. Verre liquide (réfraction des bords, façon liquid-glass-js) sur le header — Chrome/Edge ordinateur seulement.
        Safari / iPhone / Firefox ne savent pas appliquer un filtre SVG en backdrop-filter : ils gardent le verre dépoli CSS. */
  function glass(){
    var ua=navigator.userAgentData,chromium=!!(ua&&ua.brands&&ua.brands.some(function(b){return /Chromium/.test(b.brand)}));
    if(!chromium||!window.matchMedia||!matchMedia('(min-width:760px) and (hover:hover) and (pointer:fine)').matches)return;
    if(matchMedia('(prefers-reduced-transparency: reduce), (prefers-contrast: more)').matches)return;
    var el=document.querySelector('.shopify-section-header #header-outer');if(!el)return;
    var NS='http://www.w3.org/2000/svg',svg=document.createElementNS(NS,'svg');
    svg.setAttribute('aria-hidden','true');svg.style.cssText='position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    svg.innerHTML='<filter id="osk-lg" x="0" y="0" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      +'<feImage x="0" y="0" result="m" preserveAspectRatio="none"/>'
      +'<feDisplacementMap in="SourceGraphic" in2="m" scale="0" xChannelSelector="R" yChannelSelector="G"/></filter>';
    document.body.appendChild(svg);
    var f=svg.querySelector('filter'),im=svg.querySelector('feImage'),dm=svg.querySelector('feDisplacementMap'),last='';
    function build(){
      var r=el.getBoundingClientRect(),w=Math.round(r.width),h=Math.round(r.height);if(w<80||h<24)return;
      if(last===w+'x'+h)return;last=w+'x'+h;
      var rad=Math.min(parseFloat(getComputedStyle(el).borderTopLeftRadius)||h/2,h/2),band=Math.min(26,h/2);
      var c=document.createElement('canvas');c.width=w;c.height=h;
      var cx=c.getContext('2d'),d=cx.createImageData(w,h),px=d.data;
      for(var j=0;j<h;j++)for(var i=0;i<w;i++){
        /* distance au bord du rectangle arrondi + normale sortante : plus on est près du bord, plus l'image se tord */
        var qx=Math.abs(i+.5-w/2)-(w/2-rad),qy=Math.abs(j+.5-h/2)-(h/2-rad),ox=Math.max(qx,0),oy=Math.max(qy,0);
        var depth=rad-(Math.min(Math.max(qx,qy),0)+Math.sqrt(ox*ox+oy*oy));
        var k=depth<band?Math.pow(1-Math.max(depth,0)/band,2):0,nx,ny;
        if(qx>0&&qy>0){var L=Math.sqrt(ox*ox+oy*oy)||1;nx=ox/L;ny=oy/L}else if(qx>qy){nx=1;ny=0}else{nx=0;ny=1}
        if(i+.5<w/2)nx=-nx;if(j+.5<h/2)ny=-ny;
        var o=(j*w+i)*4;px[o]=128+nx*k*127;px[o+1]=128+ny*k*127;px[o+2]=128;px[o+3]=255;
      }
      cx.putImageData(d,0,0);
      f.setAttribute('width',w);f.setAttribute('height',h);im.setAttribute('width',w);im.setAttribute('height',h);
      im.setAttribute('href',c.toDataURL());dm.setAttribute('scale',String(-Math.round(band*1.8)));
      document.documentElement.classList.add('osk-lg');
    }
    build();var t=0;function later(){clearTimeout(t);t=setTimeout(build,150)}
    window.addEventListener('resize',later);if(window.ResizeObserver)new ResizeObserver(later).observe(el);
  }
  function go(){cleanArrows();reveal();rows();try{glass()}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
